import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  Modal,
  Grid,
  Stack,
  Pagination,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";

// import DatePicker from "react-datepicker";
import EventIcon from "@mui/icons-material/Event";
import SearchIcon from "@mui/icons-material/Search";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import UserCard from "./userCard";
import Swal from "sweetalert2";
import { getStockDetail } from "../stocks/stockApi";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PurchaseItemCard from "./purchaseItemCard";
import { convertDateFormat, swalAlertPopProps } from "../../utils/commonUtils";
import { postPurchaseDetail } from "./purchaseApi";
import { validationAddPurchase } from "./purchaseValidationFunction";
import { totalPriceInventory } from "./purFunction";
import { ModalHeader } from "../../common/modalHeader";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

export default function PuchaseModal({
  open,
  setOpen,
  getPurchase,
  searchItem,
  setSearchItem,
  purchaseItem,
  setPurchaseItem,
  payload,
  search,
  setSearch,
  openSearch,
  setOpenSearch,
}) {
  //   const [pagination, setPagination] = useState({ page: 1, total: 10 });
  // const [search, setSearch] = useState("");

  const data = {
    customerMobile: "",
  };
  const [billData, setBillData] = useState(data);

  const onClose = () => {
    setOpen(false);
  };
  const handleChange = (event, value) => {
    setPagination({
      ...pagination,
      page: value,
    });
  };

  // const [searchItem, setSearchItem] = useState([]);
  const getStocks = async (param) => {
    await getStockDetail(param)
      .then((res) => {
        console.log("purhcse element ", res);
        setPagination({
          ...pagination,
          total: res?.data?.totalPages,
          records: res?.data?.totalRecords,
        });
        setSearchItem(res?.data?.itemsDetails);
      })
      .catch((err) => {
        console.log("err ", err);
      });
  };

  const stockPayload = {
    page: 1,
    pageSize: 1000000,
  };

  const [purchaseItemsArr, setPurchaseItemsArr] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    total: 10,
    records: 0,
  });

  useEffect(() => {
    if (open === true) {
      getStocks(stockPayload);
    } else {
      console.log("close");
      setPurchaseItem(payload);
      setPurchaseItemsArr([]);
    }
  }, [open]);
  const addLeadingZero = (value) => {
    return value < 10 ? "0" + value : value;
  };
  const [date, setDate] = useState(dayjs());
  const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD")); // formatted for API or DB
  // const [startDate, setStartDate] = useState(new Date());
  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const addData = async (param) => {
    try {
      const res = await postPurchaseDetail(param);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully added record",
          icon: "success",
          ...swalAlertPopProps,
        }).then(() => {
          getPurchase();
          setOpen(false);
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    } catch (err) {
      console.log("err ", err);
    }
  };

  // const [status, setStatus] = useState("all");

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: {
            xs: "95%", // Mobile
            sm: "75%",
            md: "70%",
            lg: "52%", // Desktop
          },
          height: {
            xs: "85vh",
            sm: "75vh",
            md: "75vh",
            lg: "75vh",
          },
          overflowY: "auto",
          position: "absolute",
          borderRadius: "10px",
          left: {
            xs: "2.5%",
            sm: "18%",
            md: "18%",
            lg: "25%",
          },
          top: {
            xs: "5%",
            sm: "8%",
            md: "12%",
          },
        }}
      >
        <ModalHeader
          title={"Purchase"}
          onClose={(data) => {
            setOpen(data);
          }}
        />
        <Grid container sx={{ position: "relative" }}>
          <Grid item xs={12} sx={{ borderRight: "1px solid #dfdfdf" }}>
            <DialogContent
              sx={{ padding: "10px 20px", borderBottom: "2px solid #01008B" }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      mt: { sm: 2, xs: 0 },
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Date"
                        maxDate={dayjs()}
                        value={
                          dayjs.isDayjs(date) ? date : date ? dayjs(date) : null
                        }
                        onChange={(newValue) => {
                          setDate(newValue); // keep as dayjs object
                          setStartDate(newValue.format("YYYY-MM-DD")); // formatted string only where needed
                        }}
                        format="DD-MM-YYYY"
                        error={!date}
                        InputLabelProps={{
                          className: "mulish",
                          sx: {
                            color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            paddingX: "7px",
                          },
                        }}
                        InputProps={{
                          style: {
                            // height: '40px',
                            // background:"yellow"
                          },
                          sx: {
                            color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            paddingX: "7px",
                          },
                        }}
                        slots={{ openPickerIcon: CalendarMonthIcon }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            placeholder: "Date",
                            size: "small",
                            InputProps: {
                              sx: {
                                background: "#fff",
                                borderRadius: 1,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              },
                            },
                          },
                          openPickerIcon: {
                            sx: {
                              color: "#000",
                              fontSize: { xs: "10px", sm: "16px" },
                            },
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ mt: { sm: 2, xs: 0 } }}>
                    <Box
                      onClick={() => {
                        setOpenSearch(true);
                      }}
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        display: "flex",
                        height: "23px",
                        justifyContent: "space-between",
                        border: "1px solid #01008B",
                        p: 1,
                        borderRadius: "4px ",
                        color: "grey",
                        "&:hover": {
                          cursor: "pointer !important",
                        },
                        mt: { sm: 2, xs: 0 },
                      }}
                    >
                      <Typography
                        variant="p"
                        sx={{
                          fontFamily: "'Montserrat', sans-serif",
                          color: "#000000",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        {purchaseItem?.description !== ""
                          ? purchaseItem?.description
                          : "Select Item"}
                      </Typography>
                      <SearchIcon
                        onClick={() => {
                          setOpenSearch(true);
                        }}
                        sx={{
                          color: (theme) => theme.palette.primary.main,
                          fontSize: { xs: "15px", sm: "15px", md: "15px" },
                          cursor: "pointer",
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ mt: { sm: 2, xs: 0 } }}>
                    <TextField
                      fullWidth
                      id="Quantity"
                      size="small"
                      label="Quantity"
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        style: {
                          // height: '40px',
                          // background:"yellow"
                        },
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      value={
                        purchaseItem?.quantity !== 0
                          ? purchaseItem?.quantity
                          : ""
                      }
                      onChange={(e) => {
                        let val = e.target.value.replace(/\D/g, "");
                        setPurchaseItem({
                          ...purchaseItem,
                          quantity: val ? Number(val) : "",
                        });
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ mt: { sm: 2, xs: 0 } }}>
                    <TextField
                      fullWidth
                      id="briefAddress"
                      size="small"
                      label="Amount"
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        style: {
                          // height: '40px',
                          // background:"yellow"
                        },
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      value={
                        purchaseItem?.price !== 0 ? purchaseItem?.price : ""
                      }
                      onChange={(e) => {
                        let val = e.target.value.replace(/\D/g, "");
                        setPurchaseItem({
                          ...purchaseItem,
                          price: val ? Number(val) : "",
                        });
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: { xs: "center", sm: "flex-end" },
                    // flexWrap: "wrap",
                    gap: 1,
                    mt: { xs: 0, sm: 1 },
                  }}
                >
                  <DialogActions
                    sx={{
                      display: "flex",
                      // flexDirection: { xs: "column", sm: "row" },
                      gap: { xs: 1, sm: 2 },
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={() => {
                        setPurchaseItem((prev) => ({
                          ...prev,
                          quantity: "",
                          price: "",
                        }));
                      }}
                      sx={{
                        px: { xs: 3, sm: 6 }, // Responsive horizontal padding
                        fontSize: { xs: "12px", sm: "14px" },
                      }}
                    >
                      Clear
                    </Button>

                    <Button
                      variant="contained"
                      onClick={() => {
                        const valid = validationAddPurchase(purchaseItem);
                        if (valid?.status) {
                          setPurchaseItemsArr([
                            ...purchaseItemsArr,
                            {
                              ...purchaseItem,
                              amount:
                                purchaseItem.price * purchaseItem.quantity,
                            },
                          ]);
                          setPurchaseItem((prev) => ({
                            ...prev,
                            quantity: "",
                            price: "",
                          }));
                        } else {
                          Swal.fire({
                            text: valid.msg,
                            icon: "warning",
                            ...swalAlertPopProps,
                          });
                          setOpen(false);
                        }
                      }}
                      sx={{
                        px: { xs: 3, sm: 6 },
                        fontSize: { xs: "12px", sm: "14px" },
                      }}
                    >
                      Add
                    </Button>
                  </DialogActions>
                </Box>
              </Grid>
            </DialogContent>
          </Grid>

          <Grid container spacing={1} sx={{ px: 2, py: 1 }}>
            <Grid item xs={5} sm={5}>
              <Typography
                sx={{
                  color: "#01008B",
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                  marginLeft: { xs: "0px", sm: "45px" },
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Item Description
              </Typography>
            </Grid>

            <Grid item xs={1} sm={2}>
              <Typography
                sx={{
                  color: "#01008B",
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                  textAlign: "right",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Qty
              </Typography>
            </Grid>

            <Grid item xs={3} sm={2}>
              <Typography
                sx={{
                  color: "#01008B",
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                  textAlign: "right",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Rate(₹)
              </Typography>
            </Grid>

            <Grid item xs={3} sm={2}>
              <Typography
                sx={{
                  color: "#01008B",
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                  textAlign: "right",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Total(₹)
              </Typography>
            </Grid>

            <Grid item xs={0} />
          </Grid>

          <Grid
            item
            xs={0.5}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Box style={{ borderRight: "1px solid #ccc", height: "100%" }} />
          </Grid>

          <Grid item xs={12} sx={{ pr: 2 }}>
            <Box
              sx={{
                height: "23vh",
                overflowY: "auto",
              }}
            >
              {purchaseItemsArr?.map((item, index) => {
                return (
                  <PurchaseItemCard
                    key={index + "purchaseitem"}
                    index={index}
                    item={item}
                    arr={purchaseItemsArr}
                    setPurchaseItemsArr={setPurchaseItemsArr}
                  />
                );
              })}
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                paddingX: "30px",
                paddingTop: "10px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                  marginLeft: "45px",
                  fontSize: { xs: "10px", sm: "16px" },
                }}
              >
                Total Amount: &nbsp;
              </Typography>
              <Box
                component="span"
                sx={{
                  fontWeight: 700,
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                  fontSize: { xs: "10px", sm: "16px" },
                }}
              >
                {" "}
                <CurrencyRupeeIcon
                  sx={{ fontSize: { xs: "10px", sm: "16px" }, fontWeight: 700 }}
                />
                {totalPriceInventory(purchaseItemsArr)}
              </Box>
            </Box>
            <Divider
              sx={{
                background: (theme) => theme.palette.primary.main,
                width: "100%",
                mt: 1,
              }}
            />
            <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                sx={{
                  width: {
                    xs: "100%",
                    sm: "70%",
                    md: "50%",
                  },
                  fontSize: { xs: "10px", sm: "16px" },
                }}
                onClick={() => {
                  // setOpen(false);
                  console.log("bill Data ", billData);
                  if (purchaseItemsArr.length === 0) {
                    Swal.fire({
                      text: "Please Add Product",
                      icon: "warning",

                      ...swalAlertPopProps,
                    });
                  } else {
                    addData({
                      date: date.format("YYYY-MM-DD"),
                      purchaseDetails: purchaseItemsArr,
                    });
                  }

                  console.log("billData ", {
                    customer: billData?.customer,
                    customerMobile: billData?.customerMobile,
                    amount: parseInt(billData?.amount),
                    isCounterSalesBill: true,
                    paymentMode: billData?.paymentMode,
                  });
                }}
              >
                Save
              </Button>
            </DialogActions>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
